import React from 'react'
import { Card } from 'antd'
import './assets/_ErrorHandler.scss'
import PropTypes from 'prop-types'

export default function ErrorHandler ({ errorList }) {
  const renderErrorList = errorList
    ? errorList.map((item) => (
    <li key={item.errors}>
      {item.errors}
    </li>
    ))
    : null

  return (
    <>
      <Card className="ErrorListCard">
        <ul>
          {renderErrorList}
        </ul>
      </Card>
    </>
  )
}

ErrorHandler.propTypes = {
  errorList: PropTypes.array
}
